export default __webpack_public_path__ + "static/media/Heartcrusher Grips.be36616c.jpg";